<template>
      <v-select
        hide-details 
        append-icon="search"
        label="Kişi Tip"
        :loading="loading"
        :items="items"
        clearable=""
        item-text="Aciklama"
        cache-items=""
        item-value="Kod"
        v-model="Kod"
      ></v-select>
</template>

<script>
import rez from '../rezervasyon'

export default {
    props:["value"],
      
    computed: {
      Kod: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue )
        },
      },
    },
  
    
    data () {
      return {
        loading: false,
        items: rez.KisiTip,
      }
    },
}


</script>